import { render, staticRenderFns } from "./ClientIncomePicker.vue?vue&type=template&id=9468fcf8&scoped=true&"
import script from "./ClientIncomePicker.vue?vue&type=script&lang=js&"
export * from "./ClientIncomePicker.vue?vue&type=script&lang=js&"
import style0 from "./ClientIncomePicker.vue?vue&type=style&index=0&id=9468fcf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9468fcf8",
  null
  
)

export default component.exports